var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pui-ball-loader pui-ball-loader__root",style:({
    '--loader-width': _vm.loaderWidth,
    '--loader-color': _vm.loaderColor,
  })},[_c('div',{staticClass:"pui-ball-loader__ball ball1"}),_c('div',{staticClass:"pui-ball-loader__ball ball2"}),_c('div',{staticClass:"pui-ball-loader__ball ball3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }